export default __webpack_public_path__ + "static/media/ritvij.c19c6520.jpg";